import React, { useEffect } from "react"
import TwoColumnRightPrimary from "#/components/views/atoms/layouts/TwoColumnRightPrimary"
import { useHistory, Link as RouterLink } from "react-router-dom"
import { TalkToCarrotLegal } from "./TalkToCarrotLegal"
import { SendMessage } from "./send-message/SendMessage"
import { talkToCarrotSource } from "./send-message/SendMessageUtil"
import { useCurrentUser } from "../context/user/UserContext"
import { FormattedMessage } from "react-intl"
import { PageLayout } from "#/features/global-ui/page-layout"
import { PageBreadcrumbHeader } from "#/features/global-ui/page-header"
import { Breadcrumbs, Breadcrumb, Box, Link, InternalIcon, Typography } from "@carrotfertility/carotene-core"
import { Paths } from "#/utils/Paths"

function lockedDownGetHelpContent() {
  return (
    <>
      <Box sx={{ marginBlockEnd: (theme) => theme.tokens.spacing.lg }}>
        <Typography variant="h3" component="h2" sx={{ marginBlockEnd: (theme) => theme.tokens.spacing.xs }}>
          <FormattedMessage defaultMessage="Send a message" />
        </Typography>
        <Typography variant="body2" color={(theme) => theme.palette.text.tertiary}>
          <FormattedMessage defaultMessage="If you're having trouble with your account or otherwise need to reach a human, send us a message." />
        </Typography>
      </Box>
      <Box>
        <Typography variant="h5" sx={{ marginBlockEnd: (theme) => theme.tokens.spacing.xs }}>
          <FormattedMessage defaultMessage="Or you might like to..." />
        </Typography>
        <Link to="/your-benefit-guide/about-your-benefit" endIcon={<InternalIcon />} component={RouterLink}>
          <FormattedMessage defaultMessage="Learn about your benefit" />
        </Link>
        <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xxs })}>
          <Link to={Paths.FAQS} component={RouterLink} endIcon={<InternalIcon />}>
            <FormattedMessage defaultMessage="Get answers to frequently asked questions" />
          </Link>
        </Box>

        <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xxs })}>
          <Link to="/carrot-plans" endIcon={<InternalIcon />} component={RouterLink}>
            <FormattedMessage defaultMessage="Start using Carrot" />
          </Link>
        </Box>
      </Box>
    </>
  )
}

function LockedDownGetHelpPage() {
  const history = useHistory()
  const { isInAppLockdown } = useCurrentUser()

  useEffect(() => {
    if (!isInAppLockdown) {
      history.push("/")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- See https://carrotfertility.atlassian.net/wiki/spaces/PE/pages/2050295461/Remove+Build+Warnings#react-hooks%2Fexhaustive-deps
  }, [isInAppLockdown])

  return (
    <PageLayout
      footer={<TalkToCarrotLegal />}
      header={
        <PageBreadcrumbHeader
          breadcrumbs={
            <Breadcrumbs>
              <Breadcrumb currentPage>
                <FormattedMessage defaultMessage="Send a message" />
              </Breadcrumb>
            </Breadcrumbs>
          }
        />
      }
    >
      <TwoColumnRightPrimary
        secondaryContent={lockedDownGetHelpContent()}
        primaryContent={<SendMessage source={talkToCarrotSource.LOCKED_DOWN_GET_HELP} />}
      />
    </PageLayout>
  )
}

export { LockedDownGetHelpPage }
